import React from 'react'
import { XCircleIcon } from "@heroicons/react/24/solid"
import EtUpdateUserMissionGoalComp from '@/pages/home/web/userImprint/EtUpdateUserMissionGoalComp' // Adjust path as needed

const EtModalUpdateUserMissionGoal = ({
  id,                       // 18 Aug 2025 - fixed, added the id of the goal
  isOpen,
  userId,
  userOrgId,
  missionId,
  missionModel,           // e.g. 'UserMissionClient'
  triggeringUrl,
  onClose,
  refetchOnSuccess,        // optional callback to refresh data
  missionName,
}) => {

    // First Created - 11 Aug 2025
    // Author - Atul Pandey
    // Purpose - Modal wrapper to update a new UserMissionGoal
    // Inherited from EtModalUpdateUserImprintMissionClient
    // Updated - 18 Aug 2025 - added the id to the prop list

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-70 flex justify-center items-start font-poppins overflow-y-auto p-4">
      <div className="bg-black p-5 rounded-lg shadow-lg shadow-black relative w-full max-w-4xl">
        {/* Close Icon */}
        <div
          className="absolute top-2 right-2 m-2 font-bold rounded-full cursor-pointer h-7 w-7 flex justify-center items-center"
          onClick={onClose}
        >
          <XCircleIcon className='text-orange-600 rounded-full hover:text-red-600 h-7 w-7' />
        </div>

        {/* Goal Creation Component */}
        <EtUpdateUserMissionGoalComp 
          id={id}                       // 18 Aug 2025 - fixed, added the id of the goal
          userId={userId}
          userOrgId={userOrgId}
          missionId={missionId}
          missionModel={missionModel}
          triggeringUrl={triggeringUrl}
          onClose={onClose}
          refetchOnSuccess={refetchOnSuccess}
          missionName={missionName}     // 18 Aug 2025 - added
        />
      </div>
    </div>
  )
}

export default EtModalUpdateUserMissionGoal